/**
 * Fake backend interceptor, mock all API
 *
 * @author Mikhail Siutsou
 * @function FakeBackendInterceptor
 * @category Interceptors
 * @param {MockAdapter} adapter mock adapter.
 */
var FakeBackendInterceptor = function FakeBackendInterceptor(adapter) {
  // You can mock all API what needed
  adapter.onPost('/oauth/token').reply(200, {
    access_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvd25lciI6ItCR0LDQvdC6INCR0LXQu9CS0K3QkSIsInVzZXJfbmFtZSI6IkFkbWluIiwic2NvcGUiOlsicmVxdWVzdHMuYWxsb3ciXSwiZXhwIjoxNjcxNDU4OTM0LCJhZGRfaW5mbyI6ItCU0L7Qv9C-0LvQvdC40YLQtdC70YzQvdCw0Y8g0LjQvdGE0L7RgNC80LDRhtC40Y8iLCJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSVklTT1IiLCJST0xFX1VTRVIiLCJST0xFX0FETUlOIl0sImp0aSI6IjZhZmEwZWI3LTMwODAtNGRlYy05ZGQwLTY1NzcxM2U1YWIzZiIsImNsaWVudF9pZCI6ImVyaXBfY2xpZW50In0.saW398bch9dETmR9MA0ygCpAT32OzVrw1Ae_Fai4E3A',
    token_type: 'bearer',
    refresh_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvd25lciI6ItCR0LDQvdC6INCR0LXQu9CS0K3QkSIsInVzZXJfbmFtZSI6IkFkbWluIiwic2NvcGUiOlsicmVxdWVzdHMuYWxsb3ciXSwiYXRpIjoiNmFmYTBlYjctMzA4MC00ZGVjLTlkZDAtNjU3NzEzZTVhYjNmIiwiZXhwIjoxNjcxNDY4OTM0LCJhZGRfaW5mbyI6ItCU0L7Qv9C-0LvQvdC40YLQtdC70YzQvdCw0Y8g0LjQvdGE0L7RgNC80LDRhtC40Y8iLCJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSVklTT1IiLCJST0xFX1VTRVIiLCJST0xFX0FETUlOIl0sImp0aSI6IjQ1Nzk0OGE3LWNkYjctNGY2NS1hMTNhLTUyMTUxYjI4ZmVkNyIsImNsaWVudF9pZCI6ImVyaXBfY2xpZW50In0.z0nhIRF_Keg69eezJGAz0sXgk8JbKa90KcF_7LHej_8',
    expires_in: 9999,
    scope: 'requests.allow',
    owner: 'Банк БелВЭБ',
    add_info: 'Дополнительная информация',
    jti: '6afa0eb7-3080-4dec-9dd0-657713e5ab3f'
  });
  adapter.onGet('/users/user-info').reply(200, {
    email: 'admin@yandex.by',
    mobilePhone: 375295774669,
    name: 'Администратор',
    createDateTime: 1670816577594,
    authorities: ['ROLE_SUPERVISOR', 'ROLE_USER', 'ROLE_ADMIN'],
    userName: 'Admin'
  });
  adapter.onGet('/users/logout').reply(200, {});
  adapter.onPost('/operations-history').reply(200, {
    content: [{
      id: 1,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 2,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CANCELED',
      user: 'Григорьев Р.И'
    }, {
      id: 3,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'REJECTED',
      user: 'Григорьев Р.И'
    }, {
      id: 4,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 5,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 6,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 7,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 8,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 9,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 10,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 11,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 12,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 13,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 14,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }, {
      id: 15,
      dealId: 10256,
      registrationDate: '2022-12-23T08:25:55.005Z',
      executionDate: '2022-12-23T08:25:55.005Z',
      currency: 'USD',
      direction: 'Продажа',
      dealAmount: 50000,
      dealRate: 2.43,
      oppositeCurrency: 'BYN',
      oppositeAmount: 121500,
      status: 'CONCLUDED',
      user: 'Григорьев Р.И'
    }],
    pageable: {
      sort: {
        empty: false,
        sorted: true,
        unsorted: false
      },
      offset: 0,
      pageNumber: 0,
      pageSize: 15,
      paged: true,
      unpaged: false
    },
    totalPages: 4,
    totalElements: 55,
    last: false,
    size: 15,
    number: 0,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false
    },
    numberOfElements: 15,
    first: true,
    empty: false
  });
  adapter.onPost('/users-management').reply(200, {
    content: [{
      id: 1
    }, {
      id: 2
    }, {
      id: 3
    }, {
      id: 4
    }, {
      id: 5
    }, {
      id: 6
    }, {
      id: 7
    }, {
      id: 8
    }, {
      id: 9
    }, {
      id: 10
    }, {
      id: 11
    }, {
      id: 12
    }, {
      id: 13
    }, {
      id: 14
    }, {
      id: 15
    }],
    pageable: {
      sort: {
        empty: false,
        sorted: true,
        unsorted: false
      },
      offset: 0,
      pageNumber: 0,
      pageSize: 15,
      paged: true,
      unpaged: false
    },
    totalPages: 4,
    totalElements: 55,
    last: false,
    size: 15,
    number: 0,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false
    },
    numberOfElements: 15,
    first: true,
    empty: false
  });
  adapter.onAny().passThrough();
};

export { FakeBackendInterceptor };